import React, { PureComponent } from 'react';
import StyledLayout from './Styled';
import Grid from '@rezdy/components/Grid';

interface ILayout {
    secondaryAction?: React.ReactElement;
}

export class Layout extends PureComponent<ILayout> {
    render() {
        const { children, secondaryAction } = this.props;
        return (
            <>
                <StyledLayout.Header>
                    <Grid.Container cols={2} colGap>
                        <Grid.Cell alignSelf="center">
                            <img className="logo" alt="Rezdy Booking Software" src="/rezdy-logo-black.svg" />
                        </Grid.Cell>
                        <Grid.Cell placeSelf="end">{secondaryAction}</Grid.Cell>
                    </Grid.Container>
                </StyledLayout.Header>
                <StyledLayout.Body>
                    <StyledLayout.Left>
                        <StyledLayout.LeftLogoWrapper>
                            <img src="/rezdy-swish.png" id="rezdy-swish-left" alt="swish" />
                            <img src="/rezdy-logo.svg" alt="rezdy-logo" id="rezdy-logo-left" />
                        </StyledLayout.LeftLogoWrapper>
                    </StyledLayout.Left>
                    <StyledLayout.Center>
                        <StyledLayout.Form>{children}</StyledLayout.Form>
                    </StyledLayout.Center>
                    <StyledLayout.Right />
                </StyledLayout.Body>
            </>
        );
    }
}

export default Layout;
